module.exports = __webpack_public_path__ + "static/media/deathgarden.813bf30c.jpg";